export const GoogleIcon = () => {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
            >
                  <path
                        fill="#FBBB00"
                        d="M6.99 13.878l-.627 2.339-2.29.048A8.96 8.96 0 013 12c0-1.492.363-2.9 1.006-4.139l2.04.374.893 2.027A5.35 5.35 0 006.649 12c0 .661.12 1.294.34 1.878z"
                  ></path>
                  <path
                        fill="#518EF8"
                        d="M20.843 10.318a9.014 9.014 0 01-.04 3.56 8.998 8.998 0 01-3.168 5.14l-2.569-.131-.363-2.27a5.364 5.364 0 002.308-2.738h-4.813v-3.56h8.645z"
                  ></path>
                  <path
                        fill="#28B446"
                        d="M17.634 19.018A8.962 8.962 0 0112 21a8.999 8.999 0 01-7.928-4.735l2.917-2.387a5.351 5.351 0 007.713 2.74l2.932 2.4z"
                  ></path>
                  <path
                        fill="#F14336"
                        d="M17.744 5.072L14.83 7.459a5.353 5.353 0 00-7.89 2.802l-2.933-2.4A8.998 8.998 0 0111.999 3c2.184 0 4.187.778 5.745 2.072z"
                  ></path>
            </svg>
      );
};
